/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, ElementRef, Renderer, ViewEncapsulation, HostBinding } from '@angular/core';
import { Inject, Optional, Host, forwardRef } from '@angular/core';

import classNames from 'classnames';

import { Table } from './table';
/**
 * 表格：标题
 */
export class TableHeader {
/**
 * 用户CSS样式
 */
class: string;
/**
 * 样式前缀
 * @return {?}
 */
get prefixCls(): string {
        return this.table && this.table.prefixCls || '';
    }
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 * @param {?} table
 */
constructor(
private _renderer: Renderer,
private _elementRef: ElementRef,
private table: Table) {

    }
/**
 * @return {?}
 */
get classes(): string {
        return classNames({
            [`${this.prefixCls}-title`]: 1
        }, this.class);
    }


static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'table-header',
    template: `<ng-content></ng-content>`,
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
{type: Table, decorators: [{ type: Inject, args: [forwardRef(() => Table), ] }, { type: Optional }, { type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'class': [{ type: Input },],
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function TableHeader_tsickle_Closure_declarations() {
/** @type {?} */
TableHeader.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TableHeader.ctorParameters;
/** @type {?} */
TableHeader.propDecorators;
/**
 * 用户CSS样式
 * @type {?}
 */
TableHeader.prototype.class;
/** @type {?} */
TableHeader.prototype._renderer;
/** @type {?} */
TableHeader.prototype._elementRef;
/** @type {?} */
TableHeader.prototype.table;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
